import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';
import { useShop } from '../context/ShopContext';

function Navigation() {
  const { cartCount, wishlistCount } = useShop();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMobileDropdown, setActiveMobileDropdown] = useState(null);

  const navItems = [
    { id: 'home', label: 'HOME', dropdown: [], path: '/' },
    {
      id: 'mens',
      label: "MEN'S",
      dropdown: [
        { label: "ALL MEN'S", path: '/mens' },
        { label: 'TOPS', path: '/mens/tops' },
        { label: 'BOTTOMS', path: '/mens/bottoms' },
        { label: 'ACCESSORIES', path: '/mens/accessories' },
      ],
      path: '/mens',
    },
    {
      id: 'womens',
      label: "WOMEN'S",
      dropdown: [
        { label: "ALL WOMEN'S", path: '/womens' },
        { label: 'TOPS', path: '/womens/tops' },
        { label: 'BOTTOMS', path: '/womens/bottoms' },
        { label: 'DRESSES', path: '/womens/dresses' },
        { label: 'ACCESSORIES', path: '/womens/accessories' },
      ],
      path: '/womens',
    },
    {
      id: 'kids',
      label: 'KIDS',
      dropdown: [
        { label: 'ALL KIDS', path: '/kids' },
        { label: 'TOPS', path: '/kids/tops' },
        { label: 'BOTTOMS', path: '/kids/bottoms' },
        { label: 'DRESSES', path: '/kids/dresses' },
        { label: 'ACCESSORIES', path: '/kids/accessories' },
      ],
      path: '/kids',
    },
    {
      id: 'about',
      label: 'ABOUT US',
      dropdown: [
        { label: 'OUR VALUES', path: '/our-values' },
        { label: 'SUSTAINABILITY', path: '/sustainability' },
        { label: 'OLDER ADULTS- HCP', path: '/older-adults' },
        { label: 'CATALOGUES & PUBLICATIONS', path: '/catalogues' },
        { label: 'TRY TSU IN PERSON', path: '/try-tsu' },
        { label: 'CONTACT US', path: '/contact' },
        { label: 'FAQS', path: '/faqs' },
        { label: 'PARTNER WITH US', path: '/partner' },
      ],
      path: '/about',
    },
    {
      id: 'biz',
      label: 'THE BIZ',
      dropdown: [
        { label: 'SHIPPING POLICY', path: '/shipping-policy' },
        { label: 'TERMS OF SERVICE', path: '/terms' },
        { label: 'RETURNS POLICY', path: '/returns' },
        { label: 'PRIVACY POLICY', path: '/privacy' },
      ],
      path: '/thebiz',
    },
    {
      id: 'what',
      label: 'WHAT WE DO',
      dropdown: [
        { label: 'ADAPTIVE CLOTHING', path: '/what/adaptive' },
        { label: 'SENSORY CLOTHING', path: '/what/sensory' },
        { label: 'CUSTOM MADE', path: '/what/custom' },
        { label: 'RESEARCH', path: '/what/research' },
      ],
      path: '/what',
    },
    { id: 'ndis', label: 'NDIS', dropdown: [], path: '/ndis' },
    { id: 'news', label: 'NEWS & MEDIA', dropdown: [], path: '/news' },
  ];

  const toggleMobileDropdown = (itemId) => {
    setActiveMobileDropdown(activeMobileDropdown === itemId ? null : itemId);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>

        {/* Logo */}
        <Link to="/" className="logo">
          <img src="/assets/tsu-logo.avif" alt="The Shapes United" />
        </Link>

        {/* Desktop Navigation */}
        <div className="nav-links">
          {navItems.map((item) => (
            <div key={item.id} className="nav-item">
              <Link to={item.path} className="nav-link">{item.label}</Link>
              {item.dropdown.length > 0 && (
                <div className="dropdown">
                  {item.dropdown.map((subItem, index) => {
                    // Check if subItem is a string (old format) or object (new format)
                    if (typeof subItem === 'string') {
                      return (
                        <div key={index} className="dropdown-item">{subItem}</div>
                      );
                    } else {
                      // New format with path
                      return (
                        <Link 
                          key={index} 
                          to={subItem.path} 
                          className="dropdown-item"
                        >
                          {subItem.label}
                        </Link>
                      );
                    }
                  })}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Search and Cart */}
        <div className="nav-right">
          <div className="search-box">
            <input type="text" placeholder="Search..." />
            <button>🔍</button>
          </div>
          <Link to="/wishlist" className="icon-link">
            <span role="img" aria-label="wishlist">♡</span>
            {wishlistCount > 0 && <span className="badge">{wishlistCount}</span>}
          </Link>
          <Link to="/cart" className="icon-link cart-icon">
            <span role="img" aria-label="cart">🛒</span>
            {cartCount > 0 && <span className="badge">{cartCount}</span>}
          </Link>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="mobile-nav">
          {navItems.map((item) => (
            <div key={item.id} className="mobile-nav-item">
              <Link 
                to={item.path}
                className="mobile-nav-link"
                onClick={(e) => {
                  if (item.dropdown.length > 0) {
                    e.preventDefault();
                    toggleMobileDropdown(item.id);
                  }
                }}
              >
                {item.label}
              </Link>
              
              {item.dropdown.length > 0 && activeMobileDropdown === item.id && (
                <div className="mobile-dropdown">
                  {item.dropdown.map((subItem, index) => {
                    if (typeof subItem === 'string') {
                      return (
                        <div key={index} className="mobile-dropdown-item">{subItem}</div>
                      );
                    } else {
                      return (
                        <Link 
                          key={index} 
                          to={subItem.path} 
                          className="mobile-dropdown-item"
                        >
                          {subItem.label}
                        </Link>
                      );
                    }
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </nav>
  );
}

export default Navigation;
